export default __webpack_public_path__ + "static/media/ec2.06761da6.svg";